import DesktopPdfDownloadButton from '../PdfDownloadButton/Desktop';
import DesktopShareButton from '../ShareButton/Desktop';
import ZoomButton from '../ZoomButton/Desktop';
import DesktopLanguageButton from '../LanguageButton/Desktop';

import * as Styled from './index.styles';

interface Props {
  fileName: string;
  domain?: string | null;
  isBulk: boolean;
  isDownloadEnabled: boolean;
  ctaFormPage?: number;
  translateKoToEn: (item: string) => string;
  isRedirectCtaFormAppropriate?: boolean;
  isShareable?: boolean;
  rightOffset?: number;
  isZoomEnabled?: boolean;
}

const DesktopViewerLayer = ({
  translateKoToEn,
  fileName,
  domain,
  isBulk,
  isDownloadEnabled,
  ctaFormPage,
  isRedirectCtaFormAppropriate,
  isShareable,
  rightOffset,
  isZoomEnabled = true,
}: Props) => {
  return (
    <Styled.StackTopRightWrapper gap={16} rightOffset={rightOffset}>
      {isZoomEnabled && <ZoomButton />}
      <DesktopLanguageButton />
      <DesktopPdfDownloadButton
        translateKoToEn={translateKoToEn}
        fileName={fileName}
        isDownloadEnabled={isDownloadEnabled}
        ctaFormPage={ctaFormPage}
        isRedirectCtaFormAppropriate={isRedirectCtaFormAppropriate}
        isBulk={isBulk}
      />
      {isShareable && (
        <DesktopShareButton
          translateKoToEn={translateKoToEn}
          domain={domain}
          isBulk={isBulk}
        />
      )}
      {/*<V1EntryPill translateKoToEn={translateKoToEn} />*/}
    </Styled.StackTopRightWrapper>
  );
};

export default DesktopViewerLayer;
